//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AthletesCanViewDashboard from './AthletesCanViewDashboard.vue';

export default {
  name: 'TeamForm',
  components: { AthletesCanViewDashboard },
  props: {
    value: {
      default: {
        name: null,
        athletesCanViewDashboard: false,
      },
    },
    loading: {
      default: false,
    },
  },
  methods: {
    propagate() {
      this.$emit('input', this.value);
    },
  },
};
